<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-input
        :style="inputStyle"
        :disabled="!isedite"
        type="text"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @keyup.enter.native="handleEnter"
        @blur="handleBlur"
      />
    </el-tooltip>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'jtDateTime',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    _validate(value) {
      const errMsg = this.$t('datetime.INCORRECT_DATETIME_FORMAT', {
        datetime: value,
      })
      Validator.isDateTime(value, this.format, errMsg)
    },
    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this._validate(value)
        this.val = moment(value, this.format).format(this.format)
        this.$emit('datas', null, this.val)
        return
      }

      this.$emit('datas', null, value)
    },
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
